import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static outlets = ['tabs'];
  static targets = ['currentStep', 'container'];
  static values = {
    currentStep: { type: Number, default: 0 }
  }

  changeBgColor() {
    const pbClass = this.hasTabsOutlet ? 'pb-7' : 'pb-1';
    this.element.classList.toggle('pt-2', window.scrollY >= 220);
    this.element.classList.toggle(pbClass, window.scrollY >= 220);
  }

  currentStepTargetConnected() {
    this.currentStepTarget.scrollIntoView({ block: 'center', inline: 'center' });
  }

  scrollToLeft() {
    this.scrollLeftInterval = setInterval(() => {
      this.containerTarget.scrollLeft -= 10;
    }, 20);
  }

  scrollToRight() {
    this.scrollRightInterval = setInterval(() => {
      this.containerTarget.scrollLeft += 15;
    }, 17.5);
  }

  clearScrollLeft() {
    clearInterval(this.scrollLeftInterval);
  }

  clearScrollRight() {
    clearInterval(this.scrollRightInterval);
  }
}
